import './styles.scss'

import Splide from '@splidejs/splide';
import { Video } from '@splidejs/splide-extension-video';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

import  Accordion  from 'accordion-js'

import fitty from 'fitty'

import * as navigation from './js/navigation.js';
import * as actus from './js/actus.js';
import * as veltystory from './js/veltystory.js';
import * as cycle from './js/cycle.js';
import * as recherche from './js/recherche.js';
const rechercheGlobale = recherche.initRecherche()

import Swup from 'swup';
import SwupSlideTheme from '@swup/slide-theme';
import SwupScrollPlugin from '@swup/scroll-plugin';
import SwupGaPlugin from '@swup/ga-plugin';
import SwupProgressPlugin from '@swup/progress-plugin';

import mediabox from 'mediabox';



import { Dropzone } from "dropzone";
//https://github.com/dropzone/dropzone

// Sliders

let temoignagesSlider
let logosSlider
let accueilPracticesSlider
let carriereSlider
let temoignageTexteSlider
let annoncesSlider

// Swup 
const swup = new Swup({
  plugins: [
    new SwupSlideTheme(),
    new SwupScrollPlugin({ 
       doScrollingRightAway: false, 
       animateScroll: false, 
       scrollFriction: 0, 
       scrollAcceleration: 0, 
    }),
    new SwupGaPlugin({
       gaMeasurementId: 'G-0T843XJ2BM',
  }),
  new SwupProgressPlugin()
  ]
});



const wpmlLinks = document.querySelectorAll('.wpml-ls-link')
wpmlLinks.forEach(function (target) {
  target.dataset.noSwup  = 'true' 
})


// swup.on('transitionEnd', init )
//
swup.on('contentReplaced', function() {
  document.querySelector('footer').style.opacity = 1
  init()
  
  window.gtag('config', 'G-0T843XJ2BM', {
       page_title: document.title,
       page_path: window.location,
       'anonymize_ip': true 
  });

});

swup.on('willReplaceContent', function() {
  document.querySelector('nav').classList.remove('is-active')
  document.querySelector('footer').style.opacity = 0
  unmount()
});

swup.on('clickLink', function() {
  fermeCV()
  document.querySelector('nav').classList.remove('is-active')
  document.querySelector('footer').style.opacity = 0
});






const unmount = function () {
  navigation.destroyMenu()
}


function randomBlurize() {

  var text = document.querySelectorAll('.titre-lettre');
  var numLetters = text.length;

  var num = Math.floor(Math.random()*numLetters);

  var lettre = text[num];
  if (lettre) {
    if (lettre.style.filter == 'blur(6px)') lettre.style.filter = 'blur(0px)';
    else  lettre.style.filter = 'blur(6px)';
  }
  

  setTimeout(randomBlurize, 300);

} 


const moveCursor = (e)=> {
  const cursor = document.querySelector('#cursor');
  const mouseY = e.pageY;
  const mouseX = e.pageX;
  cursor.style.transform = `translate3d(${mouseX-33}px, ${mouseY-33}px, 0)`;

}




const init = function () {  

  const html = document.querySelector('html');
  html.classList.remove("fixe")

  // Curseurs
  let curseurs = document.querySelectorAll('[data-curseur]') 
  curseurs.forEach(item => {
    item.addEventListener('mouseenter', event => {
        const type = item.dataset.curseur
        document.querySelector('#cursor').className = type
        window.addEventListener('mousemove', moveCursor)
        document.querySelector('#cursor').style.display = 'block'
        item.style.cursor = 'none'
    })
    item.addEventListener('mousemove', event => {
        const type = item.dataset.curseur
        document.querySelector('#cursor').className = type
        window.addEventListener('mousemove', moveCursor)
        document.querySelector('#cursor').style.display = 'block'
        item.style.cursor = 'none'
    })

    item.addEventListener('mouseleave', event => {
        window.removeEventListener('mousemove', moveCursor)
        document.querySelector('#cursor').style.display = 'none'
        document.querySelector('#cursor').className = ''
    })
    item.addEventListener('click', event => {
        window.removeEventListener('mousemove', moveCursor)
        document.querySelector('#cursor').style.display = 'none'
        document.querySelector('#cursor').className = ''
    })
  })

  // Hauteur du conteneur offres
  if (document.querySelector('.titre-offre')) {
    randomBlurize()
    //fondTitreHeight()
    animAccroche()
  }


  // FAQ
  if (document.querySelector('.accordion-container')) {
    new Accordion('.accordion-container');
  }


 

  



  // Page de recherche 
  if (document.querySelector('#recherche-page')) {
    const recherchePage = recherche.initRecherchePage()
  }

  // Veltystory
  if (document.querySelector('.bloc-veltystory-conteneur'))  veltystory.initStory()

  // Page actualités
  if (document.querySelector('#archive-actualites')) initActualites()

  // Page Blog
  if (document.querySelector('#archive-blog')) initBlog()

  // Animer l'accueil
  if (document.querySelector('.bloc-accueil-header__debut')) {
    initAccueil()
    //if (document.querySelector('body.mobile') === null) cycle.initCycle()
  }

  // Animer le compteur
  if (document.querySelector('.bloc-chiffre-valeur')) initCompteur()


  // Init page Carrière
  if (document.querySelector('.conteneur-carriere')) initCarriere();

  initReveal()
  initSlider()


  if (document.querySelector('.bloc-titreoffres')) document.querySelector('.bloc-titreoffres').classList.add('anim-titre')
  
  navigation.fermeMenu()
  navigation.ouvertureMenu()


  if (document.querySelector('.bloc-chiffre-valeur')) {
    


    const largeur = window.innerWidth
    if (largeur<800) {
       var fit = fitty('.bloc-chiffre-valeur', {
        minSize: 16,
        maxSize: 100,
       });
    } else {
       var fit = fitty('.bloc-chiffre-valeur', {
        minSize: 12,
        maxSize: 200,
       });
    }
  }
  
  // Init des cv page équipe
  if (document.querySelector('.bloc-equipe')) initCvEquipe()

  // Init des cv pages
  if (document.querySelector('.cv-page')) initCv()

}


// Gestion reveal

const threshold = .1
const options = {
  root: null,
  rootMargin: '0px',
  threshold
}

const initReveal = function () {
  const handleIntersect = function (entries, observer) {
    entries.forEach(function (entry) {
       if (entry.intersectionRatio > threshold) {
        entry.target.classList.remove('reveal')
        observer.unobserve(entry.target)
       }
    })
  }
  document.documentElement.classList.add('reveal-loaded')

  const observer = new IntersectionObserver(handleIntersect, options)
  const targets = document.querySelectorAll('.reveal')
  targets.forEach(function (target) {
    observer.observe(target)
  })
}


// Gestion compteur 

const initCompteur = function () {
  const handleIntersectCompteur = function (entries, observer) {
    entries.forEach(function (entry) {
       if (entry.intersectionRatio > threshold) {
        animateValue(entry.target)
        observer.unobserve(entry.target)
       }
    })
  }
 
  const observer = new IntersectionObserver(handleIntersectCompteur, options)
  const targets = document.querySelectorAll('.bloc-chiffre-valeur')
  targets.forEach(function (target) {
    observer.observe(target)
  })
}


const initActualites = function () {
  actus.init()
  const recupActus = actus.getActus('actualites')
}

const initBlog = function () {
  actus.init()
  const recupActus = actus.getActus('blog')
}


const animAccroche = function () {
}


const initCarriere = function() {


  if( carriereSlider) carriereSlider.destroy()

  carriereSlider = new Splide( '.bloc-carriere-mosaique-valeurs-slide', {
    //arrows    : false,
    pagination:true,
    type    : 'loop',
    keyboard: true,
    perPage: 1,
    perMove: 1,
    autoplay:true

}  ).mount();  

if( temoignageTexteSlider) temoignageTexteSlider.destroy()

temoignageTexteSlider = new Splide( '.bloc-carriere-mosaique-temoignages-splide', {
  //arrows    : false,
  pagination:true,
  type    : 'loop',
  keyboard: true,
  perPage: 1,
  perMove: 1,
  autoplay:true

}  ).mount();  

if( annoncesSlider) annoncesSlider.destroy()

annoncesSlider = new Splide( '.bloc-carriere-annonces-splide ', {
  arrows    : true,
  pagination:false,
  //type    : 'loop',
  keyboard: true,
  perMove: 1,
  fixedWidth: '240px',
}).mount();  

  //const dropzone = new Dropzone("#dropzone", { url: "/file/post" });

  mediabox('.mediabox');

}

document.querySelector('.fermer-cv').addEventListener('click', event => {
  fermeCV();
})

const fermeCV = function () {
  document.querySelector('html').classList.remove('fixe')
  document.querySelector('.cv-overlay').classList.remove('actif')
}

const initCv = function () {
  document.querySelectorAll('.cv-page').forEach(item => {
    item.addEventListener('click', event => {
       document.querySelector('.cv-overlay').classList.add('actif')
       afficheCV(event);
    })
  })
 
}

const afficheCV = function(e) {
  const id = e.currentTarget.dataset.personne

  document.querySelector('html').classList.add('fixe')
  document.querySelector('.cv-overlay').classList.add('actif')

  document.querySelector('.cv-contenu').innerHTML = ''
  // Récupération contenu
    const url =window.location.origin+'/wp-json/veltys/v1/cv?id='+id
    
       fetch(url)
        .then((resp) => resp.json())
        .then(function(data) {
          document.querySelector('.cv-contenu').innerHTML = data
       });    
}

const initCvEquipe = function () {
  document.querySelectorAll('.bloc-personne.cv-equipe').forEach(item => {
    item.addEventListener('click', event => {
       afficheCVEquipe(event);
    })
  })
}

const afficheCVEquipe = function (e) {

  const id = e.currentTarget.dataset.personne

  // position de l'étiquette
  const portraitTaille = e.currentTarget.getBoundingClientRect()
  const centrePortrait = ( portraitTaille.x + (portraitTaille.width/2) )
  let newPos = (-2500/2) + centrePortrait;

  if (window.innerWidth > 800 )newPos = newPos-54;
  e.currentTarget.querySelector('.bloc-personne-cv-masque').style.backgroundPosition = newPos+'px 0';

  

  document.querySelectorAll('.bloc-personne').forEach(item => {
    let temp_id = item.dataset.personne
     if( id != temp_id) item.classList.remove('actif')
  })

  e.currentTarget.classList.toggle('actif')

  //e.currentTarget.style.height = 
}


const initAccueil = function() {

  // Anim intro
  document.querySelector('.bloc-accueil-header__debut').classList.remove('bloc-accueil-header__debut')


  // Gestion slider visuels
  if (accueilPracticesSlider) accueilPracticesSlider.destroy()

  accueilPracticesSlider = new Splide( '.bloc-accueil-practices-visuels', {
    type    : 'loop',
    arrows    : false,
    drag    : false,
  focus  : 'center',
    pagination:false,
    keyboard: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    pauseOnDotsHover: false,
    swipe : false,
    autoScroll: {
       speed: 2,
    },
    autoWidth: true,
    perPage: 4,
    breakpoints: {
     640: {
       perPage: 1,
     },
     1024: {
       perPage: 3,
     },
     1200: {
       perPage: 4,
     },
    }
}).mount( { AutoScroll } );  


}

const initSlider = function () {

  if (document.querySelector('.bloc-temoignages')) {
    if (temoignagesSlider) temoignagesSlider.destroy()

     temoignagesSlider = new Splide( '.bloc-temoignages', {
       arrows    : true,
       pagination:true,
       keyboard: true,
       type:'loop',
       hideControls:true
  
    }  ).mount( { Video } );  
  }

  if (document.querySelectorAll('.bloc-slider-logos-slider')) {

    const sliders =  document.querySelectorAll('.bloc-slider-logos-slider') 
    sliders.forEach(item => {
        const id = item.id
        new Splide( '#'+id, {
          arrows    : true,
          pagination:false,
          type    : 'loop',
          keyboard: true,
          autoplay:true,
          perPage: 5,
          perMove: 1,
          breakpoints: {
             640: {
               perPage: 1,
               pagination:true,
             },
             1024: {
               perPage: 3,
             },
             1200: {
               perPage: 4,
             },
          }
       
        }  ).mount();  
    })

  //    if( logosSlider) logosSlider.destroy()

  //    logosSlider = new Splide( '.bloc-slider-logos-slider', {
  //     arrows    : true,
  //     pagination:false,
  //     type    : 'loop',
  //     keyboard: true,
  //     autoplay:true,
  //     perPage: 5,
  //     perMove: 1,

  //     breakpoints: {
  //        640: {
  //          perPage: 1,
  //          pagination:true,
  //        },
  //        1024: {
  //          perPage: 3,
  //        },
  //        1200: {
  //          perPage: 4,
  //        },
  //     }
  
  //    }  ).mount();  
  
  }

}


document.addEventListener("DOMContentLoaded", function(event) { 
    init()
    window.onresize = init;
});





const animateValue = function (obj, start = 0, end, duration = 1500) {
  if (obj) {
       // save starting text for later (and as a fallback text if JS not running and/or google)
       var textStarting = obj.innerHTML;

    //  if (textStarting.includes(",")) return false;

       // remove non-numeric from starting text if not specified
       end = end || parseInt(textStarting.replace(/\D/g, ""));

       var range = end - start;

       // no timer shorter than 50ms (not really visible any way)
       var minTimer = 50;

       // calc step time to show all interediate values
       var stepTime = Math.abs(Math.floor(duration / range));

       // never go below minTimer
       stepTime = Math.max(stepTime, minTimer);

       // get current time and calculate desired end time
       var startTime = new Date().getTime();
       var endTime = startTime + duration;
       var timer;

       function run() {
        
          var now = new Date().getTime();
          var remaining = Math.max((endTime - now) / duration, 0);
           var value = Math.round(end - (remaining * range));
           // replace numeric digits only in the original string
          obj.innerHTML = textStarting.replace(/([0-9]+)/g, value);
          if (value == end) {
               clearInterval(timer);
          }
       }

       timer = setInterval(run, stepTime);
       run();
  }
}



// Hauteur du fond du titre Offres

// const fondTitreHeight = function() {

//    if ( document.querySelector('.bloc-titreoffres__offres')) {
//     const fond = document.querySelector('.bloc-titreoffres-fond')
//     const rect = document.querySelector('.bloc-titreoffres-visuel').getBoundingClientRect();
    
//     fond.style.height = `${rect.top + rect.height - 80}px`
  
//    }
 
// }
